<div class="row g-0">
  <label class="col-12 py-0" for="segmentDropdown"
    >Choose a segment for the link
  </label>
  <p-select
    (onChange)="emitSegmentChange()"
    [options]="segments"
    [(ngModel)]="selectedSegment"
    optionLabel="displayName"
    placeholder="Select a segment"
    [showClear]="true"
    [style]="{ width: '100%', zIndex: '3' }"
    name="segmentDropdown"
    class="col-12"
  >
    <ng-template pTemplate="selectedItem">
      <div class="flex align-items-center gap-2" *ngIf="selectedSegment">
        <div>{{ selectedSegment.displayName }}</div>
      </div>
    </ng-template>
    <ng-template let-segment pTemplate="item">
      <div class="flex align-items-center gap-2 block-item-content">
        {{ segment.displayName }}
      </div>
    </ng-template>
  </p-select>
</div>
